export default __webpack_public_path__ + "static/Umbau-d97aa1a39d17af30c4dbd6b52b4e7268.jpg";